/**
 * Shared control sizing — matches Supabase packages/ui SIZE_VARIANTS.
 * @see https://supabase.com/design-system/docs/components/button
 * Default (unspecified size) = small (34px).
 */
export const CONTROL_SIZES = {
  tiny: {
    height: "h-[26px]",
    text: "text-xs",
    px: "px-2.5 py-1",
    iconPx: 14,
    iconClass: "size-3.5",
  },
  small: {
    height: "h-[34px]",
    text: "text-sm leading-4",
    px: "px-3 py-2",
    iconPx: 18,
    iconClass: "size-[18px]",
  },
  medium: {
    height: "h-[38px]",
    text: "text-sm",
    px: "px-4 py-2",
    iconPx: 20,
    iconClass: "size-5",
  },
  large: {
    height: "h-[42px]",
    text: "text-base",
    px: "px-4 py-2",
    iconPx: 20,
    iconClass: "size-5",
  },
  xlarge: {
    height: "h-[50px]",
    text: "text-base",
    px: "px-6 py-3",
    iconPx: 24,
    iconClass: "size-6",
  },
} as const;

export type ControlSize = keyof typeof CONTROL_SIZES;

export const CONTROL_SIZE_ORDER: ControlSize[] = [
  "tiny",
  "small",
  "medium",
  "large",
  "xlarge",
];

/** Standalone icon defaults (Solar via @/components/ui/icons). */
export const ICON_SIZES = {
  inline: 16,
  header: 20,
  default: 24,
} as const;
